import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type React from "react";
import {memo, useMemo} from "react";

import {ListingIcon} from "../../react";
import {Center} from "../ui/center";
import {Image} from "../ui/image";

type Size = "xs" | "sm" | "md";

export type Props = {
    size?: Size;
    thumbnail?: string;
};

const style = tva({
    base: "overflow-hidden border-2 border-white shrink-0",
    variants: {
        size: {
            xs: "w-8 h-8 rounded-sm",
            sm: "w-12 h-12 rounded-md",
            md: "w-16 h-16 rounded-lg"
        } satisfies Record<Size, string>,
        icon: {
            true: ""
        }
    }
});

const ListingThumbnail: React.FC<Props> = ({thumbnail, size = "md"}) => {
    const thumbnailSource = useMemo(() => {
        if (thumbnail) {
            return {
                uri: thumbnail
            };
        }
    }, [thumbnail]);

    return (
        <Center
            className={style({
                size
            })}
            testID="listing-thumbnail"
        >
            {thumbnailSource ? (
                <Image alt="listing image" className="w-full h-full" source={thumbnailSource} />
            ) : (
                <ListingIcon
                    className={style({
                        icon: true,
                        size
                    })}
                />
            )}
        </Center>
    );
};

export default memo(ListingThumbnail);
